"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._heading = undefined;

var _setImmediate2 = require("babel-runtime/core-js/set-immediate");

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _glamor = require("glamor");

var _auth = require("redux/modules/auth");

var authActions = _interopRequireWildcard(_auth);

var _reduxForm = require("redux-form");

var _loginFormValidation = require("utils/loginFormValidation");

var _loginFormValidation2 = _interopRequireDefault(_loginFormValidation);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _jsonwebtoken = require("jsonwebtoken");

var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);

var _utils = require("./../../utils");

var _RedirectToExternalSite = require("./../../utils/RedirectToExternalSite");

var _SignInWithEpicButton = require("../../EpicMigration/components/SignInWithEpicButton");

var _SignInWithEpicButton2 = _interopRequireDefault(_SignInWithEpicButton);

var _Header = require("../../EpicMigration/components/Header");

var _Header2 = _interopRequireDefault(_Header);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _SubmitArtPopup = require("@quixeltools/quixel-ui-library/dist/components/common/gallery/SubmitArtPopup");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _Login = require("./Login.scss");

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var textInput = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(1)
});

var submitButton = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(2),
  textAlign: "center",
  display: "block",
  "& button": {
    paddingLeft: (0, _css.unitRem)(2.5),
    paddingRight: (0, _css.unitRem)(2.5),
    fontSize: (0, _css.unitRem)(0.625)
  },
  "& a": {
    paddingLeft: (0, _css.unitRem)(2.5),
    paddingRight: (0, _css.unitRem)(2.5),
    fontSize: (0, _css.unitRem)(0.625)
  }
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  // marginLeft: unitRem(1),
  display: "inline",
  marginTop: "unset",
  textAlign: "left"
}), (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  "& button": {
    fontSize: "1rem!important"
  },
  "& a": {
    fontSize: "1rem!important"
  }
}));

var signinWithQuixelHeading = (0, _glamor.css)({
  width: "100%",
  textAlign: "center",
  display: "block",
  fontSize: "15px",
  color: "#777",
  marginTop: "40px"
});
var signinWithQuixel = (0, _glamor.css)({});
var textSeparator = (0, _glamor.css)({
  margin: "0px 10px",
  border: "1px solid #555",
  height: "14px",
  display: "inline-flex",
  marginBottom: "-2px"
});

var signinWithQuixelBorder = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(2),
  marginBottom: (0, _css.unitRem)(2),
  height: 2,
  width: "100%",
  // position:'absolute',
  background: "#0a0a0a"
});

var foot = (0, _glamor.css)({
  display: "block",
  textAlign: "center",
  // alignItems: "baseline",
  marginTop: (0, _css.unitRem)(2),
  lineHeight: "normal"
  // minWidth(breakpoints.mediumSmall)({
  //   display: "flex",
  //   alignItem: "center",
  //   justifyContent: "space-between"
  // }),
  // minWidth(breakpoints.xxlarge)({
  //   justifyContent: "flex-end"
  // })
});

var _heading = exports._heading = (0, _glamor.css)({
  display: "block",
  position: "relative",
  paddingLeft: 0,
  paddingTop: 0
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline-block",
  paddingTop: "1rem",
  paddingLeft: "1.5rem"
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({
  paddingTop: "1.2rem"
}));

var textLink = (0, _glamor.css)(_fonts.popupTextbtn, {
  display: "block",
  marginTop: (0, _css.unitRem)(1),
  fontWeight: "400!important",
  letterSpacing: "-0.5px",
  lineHeight: "normal"
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline",
  marginTop: "unset"
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({
  "& a": {
    fontSize: "1rem"
  }
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  textAlign: "center"
}));

var linksContainer = (0, _glamor.css)({
  textAlign: "center",
  marginTop: "40px"
});
var signinContainer = (0, _glamor.css)({
  "& form": {
    width: "auto !important"
  }
});

var NewSignInPopup = function NewSignInPopup(props) {
  return _react2.default.createElement(
    "div",
    { className: signinContainer },
    _react2.default.createElement(_Header2.default, { title: "Sign In" }),
    _react2.default.createElement(
      _components.Form,
      {
        className: (0, _glamor.css)(_SubmitArtPopup.popup),
        error: props.error,
        onSubmit: props.onSubmit,
        onChildRef: props.onChildRef,
        autoCompleteProp: "off"
      },
      _react2.default.createElement(
        "div",
        { className: _Login2.default.loginWithEpicButtonWrap },
        _react2.default.createElement(_SignInWithEpicButton2.default, null)
      ),
      _react2.default.createElement("div", { className: signinWithQuixelBorder }),
      _react2.default.createElement(
        "div",
        { className: signinWithQuixel },
        _react2.default.createElement(
          "span",
          { className: signinWithQuixelHeading },
          "SIGN IN WITH QUIXEL"
        ),
        _react2.default.createElement(
          "div",
          { className: textInput },
          _react2.default.createElement(_components.TextInput, (0, _extends3.default)({
            label: "Email",
            type: "email",
            disabled: props.signingIn,
            autoCompleteProp: "username"
          }, props.emailInputProps, {
            autoFocus: true
          }))
        ),
        _react2.default.createElement(
          "div",
          { className: textInput },
          _react2.default.createElement(_components.TextInput, (0, _extends3.default)({
            label: "Password",
            type: "password",
            disabled: props.signingIn
          }, props.passwordInputProps, {
            autoCompleteProp: "current-password"
          }))
        )
      ),
      _react2.default.createElement(
        "div",
        { className: linksContainer },
        _react2.default.createElement(_SignInWithEpicButton2.default, {
          registerLinkStyles: textLink,
          isRegisterLinkVariant: true
        }),
        _react2.default.createElement("span", { className: textSeparator }),
        _react2.default.createElement(_components.TextButtonLibrary, {
          className: textLink,
          mode: "small",
          to: props.forgotPasswordTo ? props.forgotPasswordTo : "",
          onClick: props.onForgotPasswordClick ? props.onForgotPasswordClick : "",
          label: "Forgot password"
        })
      ),
      _react2.default.createElement("div", { className: signinWithQuixelBorder }),
      _react2.default.createElement(
        "div",
        { className: foot },
        _react2.default.createElement(_Button2.default, {
          small: true,
          type: "submit",
          className: submitButton,
          mode: "secondary",
          loading: props.signingIn,
          label: "Sign in"
        })
      )
    )
  );
};

var container = (0, _glamor.css)({
  border: "none",
  marginTop: "3.75em",
  width: "100%"
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  border: "1px solid #333",
  margin: "80px auto",
  width: 500
}));

var Login = (_dec = (0, _reduxForm.reduxForm)({
  form: "login",
  fields: ["email", "password"],
  validate: _loginFormValidation2.default
}, function (state) {
  return {
    auth: state.auth,
    avatarfileName: state.auth.avatarfileName
  };
}, (0, _extends3.default)({}, authActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login(props) {
    (0, _classCallCheck3.default)(this, Login);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call(this, props));

    _this.onLoginSubmit = _this.onLoginSubmit.bind(_this);

    _this.state = {
      transitioned: false
    };
    return _this;
  }

  (0, _createClass3.default)(Login, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      //document.body.style.position = "fixed";
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          location = _props.location,
          auth = _props.auth;

      if (auth.loggedIn && location.query.return_to && (location.query.return_to.indexOf("quixel.zendesk.com") > -1 || location.query.return_to.indexOf("help.quixel.com") > -1 || location.query.return_to.indexOf("zendesk.com") > -1)) {
        this.props.loginWithSSOZendesk({});
      }

      var _interval_ = setInterval(IgnoreElement, 1000);

      function IgnoreElement() {
        if (typeof CE2 !== "undefined") {
          var elP = document.getElementsByTagName("input").password;
          var elE = document.getElementsByTagName("input").email;
          var list = CE2.ignoredElements;

          if (elP) CE2.ignore(elP);
          if (elE) CE2.ignore(elE);

          if (CE2.ignoredElements.length > 0) clearInterval(_interval_);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.style.position = "inherit";
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _props2 = this.props,
          location = _props2.location,
          navigateTo = _props2.navigateTo;


      if (nextProps.auth.loggedIn && !this.state.transitioned) {
        this.setState({ transitioned: true });

        var returnTo = location.query.returnTo && location.query.returnTo.indexOf("signup") === -1 ? location.query.returnTo : "/";
        if (!navigateTo && location.query.returnTo) (0, _setImmediate3.default)(function () {
          _this2.context.router.push(returnTo);
        });
      }
      if (nextProps.auth.zendeskTokenSSO && nextProps.auth.zendeskTokenSSO !== this.props.auth.zendeskTokenSSO) {
        var tokenObject = _jsonwebtoken2.default.decode(nextProps.auth.zendeskTokenSSO);
        if (_underscore2.default.isEmpty(tokenObject.name)) {
          this.context.dialogs.custom(_react2.default.createElement(_components.ZendeskScreenNamePopupContainer, null));
        } else {
          console.log("redirect");
          if (location.query.return_to) {
            var return_to = location.query.return_to;
            var hostName = "https://" + (0, _utils.extractHostname)(return_to);
            if (!/\d/.test(hostName)) {
              hostName = "https://quixel.zendesk.com";
            }
            var zendeskJwtLink = hostName + "/access/jwt?jwt=" + nextProps.auth.zendeskTokenSSO + "&return_to=" + encodeURIComponent(return_to);
            (0, _RedirectToExternalSite.checkRedirectRequired)(zendeskJwtLink);
          }
        }
      }
      if (nextProps.auth.avatarSrc && this.props.auth.avatarSrc !== nextProps.auth.avatarSrc) {
        this.props.uploadAvatarZendesk(nextProps.auth.avatarSrc);
      }
      if (this.props.auth.screenName !== nextProps.auth.screenName && nextProps.auth.screenName && this.props.auth.zendeskTokenSSO) {
        var data = {
          token: this.props.auth.zendeskTokenSSO,
          screenName: nextProps.auth.screenName
        };
        if (this.props.auth.avatarfileName) data.avatarUrl = this.props.auth.avatarfileName;
        this.props.updateScreenNameSSOZendesk(data);
      }
    }
  }, {
    key: "onLoginSubmit",
    value: function onLoginSubmit(values, dispatch) {
      var _this3 = this;

      var _props3 = this.props,
          closePopup = _props3.closePopup,
          location = _props3.location;
      var email = values.email,
          password = values.password;


      return this.props.login({ email: email, password: password }).then(function (res) {
        if (window) {
          window.localStorage.setItem("quixelLogin", true);
        }

        // Open trial dialog if user is not subscribed and have not used trial before
        var user = res.user;
        var subscription = user.subscription,
            megascansTrial = user.megascansTrial;

        var subscribed = subscription && subscription.isActive;

        if (closePopup) {
          closePopup();
        }
        var return_to = location.query.return_to || location.query.redirect_to || location.query.returnTo || "";

        if (return_to.indexOf("/megascans/") > -1) {
          (0, _RedirectToExternalSite.checkRedirectRequired)(return_to);
          return;
        }
        var returnTo = location.query.returnTo && location.query.returnTo.indexOf("login") === -1 ? location.query.returnTo : "/";
        if (location.query.return_to && (location.query.return_to.indexOf("quixel.zendesk.com") > -1 || location.query.return_to.indexOf("help.quixel.com") > -1 || location.query.return_to.indexOf("zendesk.com") > -1)) {
          _this3.props.loginWithSSOZendesk({ email: email, password: password, realm: "megascans" });
          //window.location=location.query.return_to;
        } else {
          var coupon = location.query.coupon;


          if (_this3.props.navigateTo) {
            _this3.context.router.push({
              pathname: _this3.props.navigateTo,
              state: { modal: true }
            });
          } else {
            if (location.query.returnTo || !closePopup) (0, _setImmediate3.default)(function () {
              _this3.context.router.push(returnTo);
            });
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props4 = this.props,
          _props4$fields = _props4.fields,
          emailInputProps = _props4$fields.email,
          passwordInputProps = _props4$fields.password,
          error = _props4.error,
          submitting = _props4.submitting,
          handleSubmit = _props4.handleSubmit,
          childReference = _props4.childReference,
          location = _props4.location;

      var helpReturnTo = location.query.return_to && (location.query.return_to.indexOf("quixel.zendesk.com/") > -1 || location.query.return_to.indexOf("help.quixel.com/") > -1 || location.query.return_to.indexOf("zendesk.com/") > -1);

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "| Sign in or register, and start creating 3D worlds today",
          documentDescription: "Log in with your Epic Games ID for free, unlimited access to the entire Megascans library, or subscribe to one of our affordable licenses."
        },
        _react2.default.createElement(NewSignInPopup, {
          icon: "/quixel_2080_logo.png",
          error: error,
          emailInputProps: emailInputProps,
          passwordInputProps: passwordInputProps,
          signingIn: submitting,
          onSubmit: handleSubmit(this.onLoginSubmit),
          signUpTo: {
            pathname: "/signup",
            query: this.props.location.query,
            state: { modal: !helpReturnTo }
          },
          forgotPasswordTo: { pathname: "/forgot", state: { modal: true } },
          onChildRef: childReference
        })
      );
    }
  }]);
  return Login;
}(_react.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class);

var LoginPopup = function (_React$Component) {
  (0, _inherits3.default)(LoginPopup, _React$Component);

  function LoginPopup() {
    (0, _classCallCheck3.default)(this, LoginPopup);
    return (0, _possibleConstructorReturn3.default)(this, (LoginPopup.__proto__ || (0, _getPrototypeOf2.default)(LoginPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginPopup, [{
    key: "render",
    value: function render() {
      var isPopup = this.props.isPopup;


      if (isPopup) {
        return _react2.default.createElement(Login, this.props);
      }

      return _react2.default.createElement(
        "div",
        { className: container },
        _react2.default.createElement(Login, this.props)
      );
    }
  }]);
  return LoginPopup;
}(_react2.default.Component);

exports.default = LoginPopup;


//////////////////
// WEBPACK FOOTER
// ./src/pages/Login/Login.jsx
// module id = 2891
// module chunks = 0